// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Link } from 'react-router-dom';
import { bool, node } from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';

import CategoriesMenu from 'Containers/Menus/Categories';
import { NETWORK_ONE_DISTRIBUTION } from 'Constants';

import Logo from 'Assets/images/logo-nod-white.png';
import Logo2x from 'Assets/images/logo-nod2@2x-white.png';

const StyledTopBar = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;

  .alertsSection {
    display: none;
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > * {
      margin: 0 10px;
    }
  }

  .CategoriesMenu {
    top: 80px;
    display: ${ props => props.sticky ? 'flex' : 'none' };

    .menu {
      top: 0;
    }

    .menuContainer {
      margin-top: 0;
      bottom: 0;
    }
  }

  .CategoriesMenuButton {
    max-width: 70px !important;
    height: 80px !important;
    padding: 0 !important;
    display: ${ props => props.sticky ? 'block' : 'none' } !important;
    position: relative !important;
    color: transparent !important;
    background-color: transparent !important;

    svg {
      color: #FFF;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) scale(1.2);
    }
  }

  @media screen and (min-width: 768px) and (max-width: ${ props => props.theme.device.tablet }) {
    padding-left: 75px;

    .CategoriesMenu {
      top: ${ props => props.sticky ? '60px' : '72px' };
      display: flex;
      overflow: scroll;
    }

    .CategoriesMenuButton {
      display: block !important;
      position: absolute !important;
      top: -8px;
      left: 0;
      width: 70px !important;
      height: 56px !important;
    }
  }

  @media screen and (max-width: ${ props => props.theme.device.mobile }) {
    .right {
      > * {
        margin: 0 6px;
      }
    }

    .alertsSection {
      display: block;
    }

    .CategoriesMenu {
      top: 50px;
      display: flex;
      overflow: scroll;
    }

    .CategoriesMenuButton {
      display: block !important;
      position: absolute !important;
      top: -8px;
      left: 0;
      width: 70px !important;
      height: 56px !important;
    }
  }
`;

const StyledLogoAnchor = styled.div`
  box-sizing: border-box;
  width: 260px;
  margin-right: 30px;

  div {
    height: 75px;
    width: auto;
    display: flex;
  }

  a {
    height: 100%;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: block;
      height: auto;
      max-height: 100%;
      max-width: 150px;
    }
  }

  @media screen and (min-width: 768px) and (max-width: ${ props => props.theme.device.laptop }) {
    width: 137px;

    div {
      height: ${ props => props.sticky ? '70px' : '90px' };

      a {
        padding: 15px;
      }
    }
  }


  @media screen and (max-width: ${ props => props.theme.device.mobile }) {
    width: 78px;
    position: absolute;
    left: 75px;
    top: -5px;

    div {
      height: 56px;
      bottom: 0;
    }
  }
`;

// const StyledLogo = styled.img`
//   display: block;
//   max-height: 100%;
//   width: auto;
// `;

const StyledMenus = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;

  @media screen and (max-width: ${ props => props.theme.device.mobile }) {
    flex-direction: column;
    align-items: flex-end;

    .right {
      margin-top: 10px;
    }
  }
`;

const TopBar = ({ canFloat, children }) => {
  const theme = useTheme();
  return (
    <StyledTopBar className="grid-container" sticky={ canFloat }>
      <CategoriesMenu />
      <StyledLogoAnchor className="logo" theme={ theme } sticky={ canFloat }>
        <div>
          <Link to="/">
            <img
              src={ Logo2x }
              srcSet={ `${Logo} 149w, ${Logo2x} 297w` }
              sizes="(max-width: 600px) 149px, 297px"
              alt={ NETWORK_ONE_DISTRIBUTION }
            />
          </Link>
        </div>
      </StyledLogoAnchor>
      <StyledMenus>
        { children }
      </StyledMenus>
    </StyledTopBar>
  );
};

TopBar.propTypes = {
  canFloat: bool,
  children: node
};

export default TopBar;
